"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _productPriceSelector = _interopRequireWildcard(require("@cimpress-technology/product-price-selector"));

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _Loading = _interopRequireDefault(require("./Loading"));

var _RuleSet = require("./RuleSet");

require("./unionSelector.css");

var _CompetitorProductsAggregator = _interopRequireDefault(require("./CompetitorProductsAggregator"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var UnionSelector =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(UnionSelector, _PureComponent);

  var _super = _createSuper(UnionSelector);

  function UnionSelector(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, UnionSelector);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getDefaultState", function (ruleSet) {
      var defaultProductState = (0, _defineProperty2["default"])({}, ruleSet.referenceId, {});

      if (_this.props.showCompetitivePricing) {
        defaultProductState.competitorProducts = {
          state: 'onLoad'
        };
      }

      return defaultProductState;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "init", function () {
      var _this$props = _this.props,
          competitorProducts = _this$props.competitorProducts,
          ruleSet = _this$props.ruleSet;
      var competitorProductsRuleSet = (0, _RuleSet.formRuleSetForCompetitorProducts)(competitorProducts, ruleSet);

      _this.setState({
        competitorProductsRuleSet: competitorProductsRuleSet,
        isLoading: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "normalize", function (attributes) {
      var v1Attributes = [];
      attributes.forEach(function (attribute) {
        var classes = attribute.classes,
            attributeKey = attribute.key;
        var attributeValue = attribute.resolvedValue;

        if (attributeValue) {
          if (classes.length) {
            classes.forEach(function (_ref) {
              var name = _ref.name;
              v1Attributes.push({
                "class": name,
                attributeKey: attributeKey,
                attributeValue: attributeValue
              });
            });
          } else {
            v1Attributes.push({
              "class": 'tenant',
              attributeKey: attributeKey,
              attributeValue: attributeValue
            });
          }
        }
      });
      return v1Attributes;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onCompetitorAggregatorChange", function (_ref2) {
      var state = _ref2.state,
          attributes = _ref2.attributes,
          validationErrors = _ref2.validationErrors;

      if (['onLoad', 'fullyResolved', 'error'].includes(state)) {
        var competitorProductsState = {
          competitorProducts: {
            state: state,
            attributes: _this.normalize(attributes),
            validationErrors: validationErrors
          }
        };
        var productsState = (0, _cloneDeep["default"])(_this.state.productsState);

        var newProductsState = _objectSpread(_objectSpread({}, productsState), competitorProductsState);

        _this.setState({
          productsState: newProductsState
        }, function () {
          return _this.props.onChange(newProductsState);
        });
      } else if (state === 'partiallyResolved') {
        var _productsState = (0, _cloneDeep["default"])(_this.state.productsState);

        if (!_productsState.competitorProducts) {
          var _newProductsState = _objectSpread(_objectSpread({}, _productsState), {}, {
            competitorProducts: {
              state: 'onLoad'
            }
          });

          _this.setState({
            productsState: _newProductsState
          }, function () {
            return _this.props.onChange(_newProductsState);
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "transformAttributes", function (v2Attributes) {
      var attributes = [];
      v2Attributes.forEach(function (_ref3) {
        var attributeKey = _ref3.key,
            attributeValue = _ref3.resolvedValue,
            classes = _ref3.classes;

        if (attributeValue) {
          if (classes && classes.length) {
            classes.forEach(function (className) {
              attributes.push({
                attributeKey: attributeKey,
                attributeValue: attributeValue,
                "class": className.name
              });
            });
          } else {
            attributes.push({
              attributeKey: attributeKey,
              attributeValue: attributeValue,
              "class": 'tenant'
            });
          }
        }
      });
      return attributes;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSkuAggregatorChange", function (response) {
      var resolvedAttributes = [];
      var selectedRow = {};
      var displayedAttributes = null;
      var unresolved;
      var violations;
      var selectedColumn;
      var state;
      var selectorResponse = JSON.parse(JSON.stringify(response));

      if (selectorResponse) {
        var _Object$entries$ = (0, _slicedToArray2["default"])(Object.entries(selectorResponse)[0], 2),
            rowKey = _Object$entries$[0],
            rowValues = _Object$entries$[1];

        selectedRow.key = rowKey;
        selectedRow.selectedValues = [];
        Object.entries(rowValues).forEach(function (_ref4) {
          var _ref5 = (0, _slicedToArray2["default"])(_ref4, 2),
              key = _ref5[0],
              value = _ref5[1];

          var resolvedAttributesKey = "".concat(rowKey, "|").concat(key);
          selectedRow.selectedValues.push(key);

          if (value.state) {
            if (value.state === _productPriceSelector.ResolutionState.fullyResolved) {
              state = _productPriceSelector.ResolutionState.fullyResolved;
            } else if (!unresolved) {
              unresolved = value;
            }

            if (!displayedAttributes) {
              displayedAttributes = [];
              value.attributes.forEach(function (attribute) {
                if (attribute.isDisplayed) {
                  displayedAttributes.push(attribute.key);
                }
              });
            }

            value.attributes = _this.transformAttributes(value.attributes);
            resolvedAttributes.push({
              key: resolvedAttributesKey,
              values: [value]
            });
          } else {
            var entries = Object.entries(value);

            if (entries && entries.length) {
              var _Object$entries$2 = (0, _slicedToArray2["default"])(Object.entries(value)[0], 2),
                  columnKey = _Object$entries$2[0],
                  columnResponses = _Object$entries$2[1];

              if (!selectedColumn) {
                selectedColumn = {
                  key: columnKey,
                  selectedValues: Object.keys(columnResponses)
                };
              }

              var values = [];
              Object.entries(columnResponses).forEach(function (_ref6) {
                var _ref7 = (0, _slicedToArray2["default"])(_ref6, 2),
                    columnValue = _ref7[0],
                    columnResponse = _ref7[1];

                if (columnResponse.state === _productPriceSelector.ResolutionState.fullyResolved) {
                  if (!displayedAttributes) {
                    displayedAttributes = [];
                    columnResponse.attributes.forEach(function (attribute) {
                      if (attribute.isDisplayed) {
                        displayedAttributes.push(attribute.key);
                      }
                    });
                  }

                  columnResponse.attributes = _this.transformAttributes(columnResponse.attributes);
                  columnResponse.key = "".concat(columnKey, "|").concat(columnValue);
                  values.push(columnResponse);
                  state = _productPriceSelector.ResolutionState.fullyResolved;
                }
              });
              resolvedAttributes.push({
                key: "".concat(rowKey, "|").concat(key),
                values: values
              });
            }
          }
        });

        if (!state) {
          if (unresolved) {
            var _unresolved = unresolved;
            state = _unresolved.state;
            violations = _unresolved.validationErrors;
          } else {
            state = 'onLoad';
          }
        }

        if (!resolvedAttributes.length) {
          resolvedAttributes = undefined;
        }

        var ruleSet = _this.props.ruleSet;
        var productsState = (0, _cloneDeep["default"])(_this.state.productsState) || {};

        if (ruleSet && ruleSet.referenceId) {
          var sku = ruleSet.referenceId;
          var _this$state = _this.state,
              oldSku = _this$state.sku,
              oldState = _this$state.state,
              oldSelectedRow = _this$state.selectedRow,
              oldSelectedColumn = _this$state.selectedColumn;

          if (!(state !== _productPriceSelector.ResolutionState.fullyResolved && sku === oldSku && state === oldState && (0, _isEqual["default"])(selectedRow, oldSelectedRow) && (0, _isEqual["default"])(selectedColumn, oldSelectedColumn))) {
            productsState[sku] = {
              resolvedAttributes: resolvedAttributes,
              selectedRow: selectedRow,
              selectedColumn: selectedColumn,
              state: state,
              violations: violations,
              displayedAttributes: displayedAttributes
            };

            _this.props.onChange(productsState);

            _this.setState({
              sku: sku,
              state: state,
              selectedRow: selectedRow,
              selectedColumn: selectedColumn,
              productsState: productsState
            });
          }
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onError", function (error) {
      if (error && error.message) {
        if (error.message === "Cannot read property 'appendChild' of null") {
          _this.setState({
            hideError: true
          });
        } else if (error.message.includes('The provided attribute selections are malformed')) {
          _this.setState({
            ignoreInitialAttributes: true
          });
        }
      }
    });
    _this.attributeAggregatorByRuleSetRef =
    /*#__PURE__*/
    _react["default"].createRef();
    _this.state = {
      isLoading: true,
      competitorProductsRuleSet: {},
      hideError: false,
      ignoreInitialAttributes: false,
      productsState: _this.getDefaultState(props.ruleSet)
    };
    return _this;
  }

  (0, _createClass2["default"])(UnionSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var productsState = this.state.productsState;

      if (!(0, _isEqual["default"])(prevProps.ruleSet, this.props.ruleSet) || !(0, _isEqual["default"])(prevProps.competitorProducts, this.props.competitorProducts) || prevProps.authToken !== this.props.authToken) {
        this.init();
      }

      if (prevProps.showCompetitivePricing !== this.props.showCompetitivePricing) {
        if (!this.props.showCompetitivePricing) {
          var newProductState = (0, _cloneDeep["default"])(this.state.productsState);
          delete newProductState.competitorProducts;
          this.setState({
            productsState: newProductState
          }, function () {
            return _this2.props.onChange(_this2.state.productsState);
          });
        } else if (this.state.productsState && !this.state.productsState.competitorProducts) {
          this.setState({
            productsState: _objectSpread(_objectSpread({}, this.state.productsState), {}, {
              competitorProducts: {
                state: 'onLoad'
              }
            })
          }, function () {
            return _this2.props.onChange(_this2.state.productsState);
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          authToken = _this$props2.authToken,
          className = _this$props2.className,
          showErrorModal = _this$props2.showErrorModal,
          ruleSet = _this$props2.ruleSet,
          showCompetitivePricing = _this$props2.showCompetitivePricing,
          initialAttributeSelections = _this$props2.initialAttributeSelections,
          showPivotConfig = _this$props2.showPivotConfig,
          requiredAttributes = _this$props2.requiredAttributes;
      var _this$state2 = this.state,
          isLoading = _this$state2.isLoading,
          competitorProductsRuleSet = _this$state2.competitorProductsRuleSet,
          hideError = _this$state2.hideError,
          ignoreInitialAttributes = _this$state2.ignoreInitialAttributes;
      var attributeConfigurations = !ignoreInitialAttributes && initialAttributeSelections || {};
      var showCompetitorAggregator = showCompetitivePricing && competitorProductsRuleSet && competitorProductsRuleSet.whiteList && competitorProductsRuleSet.whiteList.length > 0;

      if (isLoading || !ruleSet) {
        return (
          /*#__PURE__*/
          _react["default"].createElement(_Loading["default"], null)
        );
      }

      var errorAlertConfiguration = {
        showErrorAlert: !!showErrorModal && !hideError
      };
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: className
        },
        /*#__PURE__*/
        _react["default"].createElement(_productPriceSelector["default"], {
          ruleSet: ruleSet,
          authToken: authToken,
          showPivotConfiguration: showPivotConfig,
          onChange: this.onSkuAggregatorChange,
          onLoad: this.onSkuAggregatorChange,
          initialSelectionsCount: 15,
          attributeConfigurations: attributeConfigurations,
          errorAlertConfiguration: errorAlertConfiguration,
          requiredAttributes: requiredAttributes,
          onError: this.onError
        }), showCompetitorAggregator ?
        /*#__PURE__*/
        _react["default"].createElement(_CompetitorProductsAggregator["default"], {
          authToken: authToken,
          competitorProductsRuleSet: competitorProductsRuleSet,
          onChange: this.onCompetitorAggregatorChange,
          initialCompetitiveAttributeSelections: {}
        }) : null)
      );
    }
  }]);
  return UnionSelector;
}(_react.PureComponent);

exports["default"] = UnionSelector;
(0, _defineProperty2["default"])(UnionSelector, "propTypes", {
  onReset: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  authToken: _propTypes["default"].string.isRequired,
  ruleSet: _propTypes["default"].shape({}).isRequired,
  showErrorModal: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  competitorProducts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    whiteList: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      attributeKey: _propTypes["default"].string.isRequired,
      attributevalue: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        value: _propTypes["default"].string.isRequired,
        description: _propTypes["default"].string
      }))
    }))
  })).isRequired,
  consumerId: _propTypes["default"].string.isRequired,
  showCompetitivePricing: _propTypes["default"].bool.isRequired,
  initialAttributeSelections: _propTypes["default"].objectOf(_propTypes["default"].any),
  initialCompetitiveAttributeSelections: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  initialPivotingSelections: _propTypes["default"].objectOf(_propTypes["default"].any),
  showPivotConfig: _propTypes["default"].bool,
  requiredAttributes: _propTypes["default"].objectOf(_propTypes["default"].any)
});
(0, _defineProperty2["default"])(UnionSelector, "defaultProps", {
  onReset: function onReset() {},
  onChange: function onChange() {},
  onError: function onError() {},
  showErrorModal: true,
  showPivotConfig: false,
  className: ''
});